export const technicalSkills = [
  { name: 'HTML / CSS / Tailwind CSS', level: 95 },
  { name: 'Git / GitHub', level: 90 },
  { name: 'React / Next.js', level: 88 },
  { name: 'TypeScript / JavaScript', level: 85 },
  { name: 'Node.js / Express.js', level: 82 },
  { name: 'Vercel / Render / Netlify', level: 82 },
  { name: 'PostgreSQL / Supabase', level: 80 },
  { name: 'Prisma / Supabase Auth', level: 78 },
  { name: 'Firebase', level: 75 },
  { name: 'Python / FastAPI', level: 72 },
  { name: 'Google Gemini / ADK', level: 68 },
  { name: 'Docker', level: 65 },
];

export const softSkills = [
  { name: 'Problem solving', level: 90 },
  { name: 'Client communication', level: 88 },
  { name: 'Requirements gathering', level: 86 },
  { name: 'Product thinking', level: 85 },
  { name: 'Self-directed learning', level: 92 },
  { name: 'Attention to detail', level: 88 },
  { name: 'On-time delivery', level: 90 },
  { name: 'Team collaboration', level: 87 },
  { name: 'Workflow analysis', level: 86 },
  { name: 'Adaptability', level: 89 },
];
